var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMylogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.57735C14.6188 3.22008 15.3812 3.22008 16 3.57735L24.3923 8.42265C25.0111 8.77992 25.3923 9.44017 25.3923 10.1547V19.8453C25.3923 20.5598 25.0111 21.2201 24.3923 21.5774L16 26.4226C15.3812 26.7799 14.6188 26.7799 14 26.4226L5.6077 21.5774C4.98889 21.2201 4.6077 20.5598 4.6077 19.8453V10.1547C4.6077 9.44017 4.98889 8.77992 5.6077 8.42265L14 3.57735Z",
    fill: "url(#paint0_linear_401_50)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_401_50",
    x1: 4.455,
    y1: 15,
    x2: 25.35,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#140066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007E86"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMylogo);
export default __webpack_public_path__ + "static/media/mylogo.830686f6bbfbf2b9e0efb68d1f341dc6.svg";
export { ForwardRef as ReactComponent };